export default "__VITE_ASSET__DYVjsPTz__"